export default {
    state: {
        cardItems: []
    },
    getters: {
        cardItems: (state) => state.cardItems,
    },
    mutations: {},
    actions: {},
    modules: {},
};